"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getRecentUploadsTab = exports.addRecentUploadsTabSidebarIcon = void 0;

require("core-js/modules/web.dom-collections.for-each.js");

/* eslint-disable @typescript-eslint/no-explicit-any */

/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
var addRecentUploadsTabSidebarIcon = function addRecentUploadsTabSidebarIcon($) {
  var iconId = "uploadcare--icon-recent";

  if (!document.getElementById(iconId)) {
    $(document.body).prepend($("\n        <svg width=\"0\" height=\"0\" style=\"position:absolute\" xmlns=\"http://www.w3.org/2000/svg\">\n          <symbol id=\"".concat(iconId, "\" viewBox=\"0 0 32 32\" fill=\"currentColor\">\n            <path fill=\"currentColor\" d=\"M16.792 5H10a1 1 0 0 0-1 1v16a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V10.958h-3.458a2.75 2.75 0 0 1-2.75-2.75V5Z\"/>\n            <path fill=\"currentColor\" d=\"M23 8.917v.208h-3.458a.917.917 0 0 1-.917-.917V5h.458L23 8.917Z\"/>\n            <path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M25 9.5a.5.5 0 0 1 .5.5v14a1.5 1.5 0 0 1-1.5 1.5H13a.5.5 0 0 1 0-1h11a.5.5 0 0 0 .5-.5V10a.5.5 0 0 1 .5-.5Z\" clip-rule=\"evenodd\"/>\n            <path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M27 11.5a.5.5 0 0 1 .5.5v14a1.5 1.5 0 0 1-1.5 1.5H15a.5.5 0 0 1 0-1h11a.5.5 0 0 0 .5-.5V12a.5.5 0 0 1 .5-.5Z\" clip-rule=\"evenodd\"/>\n          </symbol>\n        </svg>\n      ")));
  }
};

exports.addRecentUploadsTabSidebarIcon = addRecentUploadsTabSidebarIcon;

var getRecentUploadsTab = function getRecentUploadsTab(recentUploadcareImages, handleSelectUploadcareImage, $) {
  return function (tabPanel) {
    var populateGrid = function populateGrid(container) {
      recentUploadcareImages.forEach(function (image) {
        var handleClick = function handleClick(e) {
          handleSelectUploadcareImage(image);
          e.preventDefault();
        };

        var imageDivEle = $('<div class="recent_tab--tile"></div>').css('background-image', "url(".concat(image.uploadcare_original_url, ")")).on('click', handleClick);
        container.prepend(imageDivEle);
      });
    };

    var headerEleStr = '<div class="uploadcare--tab__header"><div class="uploadcare--text uploadcare--text_size_large uploadcare--tab__title">Recent uploads</div></div>';
    $(headerEleStr).appendTo(tabPanel);
    populateGrid($('<div class="recent_tab--grid_container"></div>').appendTo($('<div class="recent_tab--container"></div>').appendTo($('<div class="uploadcare--tab__content"></div>').appendTo(tabPanel))));
  };
};

exports.getRecentUploadsTab = getRecentUploadsTab;